import React from "react";
import { Link } from "react-router-dom";

const IndividualResultsFooter: React.FC = () => {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-[1155px] px-5 sm:px-6 lg:px-8 py-16 lg:py-24">
        {/* Heading */}
        <div className="text-center">
          <p className="text-[#3b4378] text-[18px] sm:text-[20px] font-medium">
            You've completed the survey! Now that you have your results, ask
            yourself these questions.
          </p>
        </div>

        {/* Questions */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mt-16 lg:mt-20">
          <div className="text-[#8a93b4] text-[18px] leading-[30px] font-medium">
            What surprised you about your results?
          </div>

          <div className="text-[#8a93b4] text-[18px] leading-[30px] font-medium">
            How do these results help you understand yourself better?
          </div>

          <div className="text-[#8a93b4] text-[18px] leading-[30px] font-medium">
            How can you use the knowledge of your results to become a better
            team player?
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#e8e8e8] mt-16 lg:mt-20 pt-8">
          <div className="text-center">
            <Link
              to="/help"
              className="text-[#3b4378] text-[18px] font-semibold underline hover:no-underline"
            >
              Still Need Assistance?
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndividualResultsFooter;